<template>
  <div class="bill-detail-container">
    <!-- 顶部基本信息 -->
    <div class="header-card">
      <div class="bill-status-tag">
        <van-tag :type="getDictTagType(BILL_STATUS, bill.status)" size="medium" plain>
          {{ getDictLabel(BILL_STATUS, bill.status) }}
        </van-tag>
      </div>
      
      <div class="bill-info-header">
        <div class="bill-code">订单号：{{ bill.code || '暂无' }}</div>
      </div>
      
      <div class="amount-display">
        <span class="amount-label">{{ bill.status === 'FINISH' ? '已收款：' : '应收款：' }}</span>
        <span class="amount-value">{{ bill.totalFee || '0.00' }}</span>
        <span class="amount-unit">元</span>
      </div>
      
      <div class="bill-basic-info">
        <div class="info-chip">
          <van-icon name="logistics" color="#1989fa" />
          <span>运输方式：{{ getDictLabel(DELIVERY_TYPE, bill.deliveryType) || '暂无' }}</span>
        </div>
        <div class="info-chip">
          <van-icon name="clock" color="#1989fa" />
          <span>发货日期：{{ bill.sendDate || '暂无' }}</span>
        </div>
        <div class="info-chip" v-if="bill.status === 'FINISH'">
          <van-icon name="passed" color="#07c160" />
          <span>付款时间：{{ bill.payFinishTime }}</span>
        </div>
      </div>
    </div>

    <!-- 分类标签页 -->
    <div class="tabs-container">
      <div class="tab-guide">
        <!-- <div class="guide-dot"></div> -->
        <!-- <span>点击查看详细信息</span> -->
      </div>
      <van-tabs v-model="activeTab" animated sticky swipeable color="#1989fa" background="#f6f9fc" title-active-color="#1989fa" title-inactive-color="#666">
        <!-- 物品与费用信息标签页 -->
        <van-tab title="物品与费用" name="goods">
          <template #title>
            <div class="custom-tab-title">
              <van-icon name="bag-o" size="20" />
              <span>物品与费用</span>
              <div class="new-tag" v-if="bill.status === 'TO_BE_PAY'">待付</div>
            </div>
          </template>
          <div class="tab-content">
            <!-- 物品信息卡片 -->
            <div class="info-card">
              <div class="card-title">
                <van-icon name="bag-o" color="#1989fa" />
                <span>物品信息</span>
              </div>
              <div class="info-group">
                <div class="info-row">
                  <span class="info-icon"><van-icon name="bag-o" color="#1989fa" size="18" /></span>
                  <span class="info-label">物品名称:</span>
                  <span class="info-value">
                    <van-tag :type="getDictTagType(GOODS_NAME, bill.goodsName)" round>
                      {{ getDictLabel(GOODS_NAME, bill.goodsName) || bill.goodsName }}
                    </van-tag>
                  </span>
                </div>
                <div class="info-row">
                  <span class="info-icon"><van-icon name="balance-list-o" color="#1989fa" size="18" /></span>
                  <span class="info-label">物品数量:</span>
                  <span class="info-value accent">{{ bill.amount || '暂无' }}</span>
                </div>
                <div class="info-row">
                  <span class="info-icon"><van-icon name="description" color="#1989fa" size="18" /></span>
                  <span class="info-label">物品规格:</span>
                  <span class="info-value">{{ bill.specifications || '暂无' }}</span>
                </div>
                <div class="info-row">
                  <span class="info-icon"><van-icon name="balance-o" color="#1989fa" size="18" /></span>
                  <span class="info-label">物品重量:</span>
                  <span class="info-value">{{ bill.goodsWeight || '暂无' }}</span>
                </div>
                <div class="info-row" v-if="bill.remark">
                  <span class="info-icon"><van-icon name="comment-o" color="#1989fa" size="18" /></span>
                  <span class="info-label">备注信息:</span>
                  <span class="info-value">{{ bill.remark }}</span>
                </div>
              </div>
            </div>
            
            <!-- 费用信息卡片 - 只对顾客显示 -->
            <div class="info-card" v-if="!isEmployee">
              <div class="card-title">
                <van-icon name="balance-pay" color="#1989fa" />
                <span>费用明细</span>
              </div>
              
              <div class="fee-list">
                <div class="fee-item" >
                  <span class="fee-label">应收款</span>
                  <span class="fee-value">¥ {{ bill.totalFee }}</span>
                </div>
                <div class="fee-item" >
                  <span class="fee-label">机场提货费</span>
                  <span class="fee-value">¥ {{ bill.planePickFee }}</span>
                </div>
                <div class="fee-item">
                  <span class="fee-label">配送费</span>
                  <span class="fee-value">¥ {{ bill.deliveryFee }}</span>
                </div>
                <div class="fee-item" >
                  <span class="fee-label">代收空运费</span>
                  <span class="fee-value">¥ {{ bill.planeFee }}</span>
                </div>
                <div class="fee-item" >
                  <span class="fee-label">代收款</span>
                  <span class="fee-value">¥ {{ bill.collectingFee }}</span>
                </div>
                <div class="fee-item total" :class="{ 'paid': bill.status === 'FINISH' }">
                  <span class="fee-label">{{ bill.status === 'FINISH' ? '已收款总计' : '应收款总计' }}</span>
                  <span class="fee-value">¥ {{ bill.totalFee || '0.00' }}</span>
                </div>
              </div>
            </div>
            
            <!-- 送货员反馈区域 - 只对员工显示且未上传过图片 -->
            <div class="info-card" v-if="isEmployee && !bill.image1">
              <div class="card-title">
                <van-icon name="photo-o" color="#ff8800" />
                <span>送货反馈</span>
              </div>
              
              <div class="feedback-section">
                <div class="feedback-label">拍照反馈（最少上传1张，最多上传2张图片）</div>
                <van-uploader
                  v-model="feedbackImages"
                  :max-count="2"
                  multiple
                  :after-read="afterRead"
                  accept="image/*"
                  upload-text="点击上传"
                  preview-size="80px"
                >
                  <template #preview-cover="{ file }">
                    <div class="preview-cover">
                      <van-icon name="cross" @click="deleteImage(file)" />
                    </div>
                  </template>
                </van-uploader>
                
                <div class="feedback-actions">
                  <van-button 
                    type="warning" 
                    round 
                    block 
                    icon="photograph" 
                    @click="submitFeedback"
                    :disabled="feedbackImages.length === 0"
                  >
                    提交反馈
                  </van-button>
                </div>
              </div>
            </div>
            
            <!-- 已上传反馈的显示 - 员工已上传过图片时显示 -->
            <div class="info-card" v-if=" bill.image1">
              <div class="card-title">
                <van-icon name="passed" color="#07c160" />
                <span>反馈图片</span>
              </div>
              
              <div class="feedback-status">
                <!-- <div class="status-message">
                  <van-icon name="success" color="#07c160" size="20" />
                  <span>反馈已提交，感谢您的配合！</span>
                </div> -->
                
                <div class="feedback-images">
                  <div class="feedback-image-item" v-if="bill.image1" @click="previewImage(bill.image1)">
                    <van-image :src="bill.image1" fit="cover" radius="8" width="120" height="120" />
                    <div class="image-overlay">
                      <van-icon name="search" size="20" color="#fff" />
                    </div>
                  </div>
                  <div class="feedback-image-item" v-if="bill.image2" @click="previewImage(bill.image2)">
                    <van-image :src="bill.image2" fit="cover" radius="8" width="120" height="120" />
                    <div class="image-overlay">
                      <van-icon name="search" size="20" color="#fff" />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </van-tab>

        <!-- 物流信息标签页 -->
        <van-tab title="物流信息" name="shipping">
          <template #title>
            <div class="custom-tab-title">
              <van-icon name="logistics" size="20" />
              <span>物流信息</span>
              <div class="new-tag" v-if="bill.arrivalDate">已到</div>
            </div>
          </template>
          <div class="tab-content">
            <div class="info-card">
              <div class="card-title">
                <van-icon name="logistics" color="#1989fa" />
                <span>发货信息</span>
              </div>
              <div class="info-group">
                <div class="info-row">
                  <span class="info-icon"><van-icon name="contact" color="#1989fa" size="18" /></span>
                  <span class="info-label">发货人:</span>
                  <span class="info-value accent">{{ bill.senderName || '暂无' }}</span>
                </div>
                <div class="info-row">
                  <span class="info-icon"><van-icon name="phone-o" color="#1989fa" size="18" /></span>
                  <span class="info-label">联系电话:</span>
                  <span class="info-value">{{ bill.senderPhone || '暂无' }}</span>
                </div>
                <div class="info-row">
                  <span class="info-icon"><van-icon name="location-o" color="#1989fa" size="18" /></span>
                  <span class="info-label">发货地址:</span>
                  <span class="info-value">{{ bill.senderAddress || '暂无' }}</span>
                </div>
              </div>
            </div>

            <div class="info-card">
              <div class="card-title">
                <van-icon name="send-gift-o" color="#1989fa" />
                <span>收货信息</span>
              </div>
              <div class="info-group">
                <div class="info-row">
                  <span class="info-icon"><van-icon name="manager" color="#1989fa" size="18" /></span>
                  <span class="info-label">收货人:</span>
                  <span class="info-value accent">{{ bill.receiverName || '暂无' }}</span>
                </div>
                <div class="info-row">
                  <span class="info-icon"><van-icon name="phone-o" color="#1989fa" size="18" /></span>
                  <span class="info-label">联系电话:</span>
                  <span class="info-value">{{ bill.phone || '暂无' }}</span>
                </div>
                <div class="info-row">
                  <span class="info-icon"><van-icon name="location" color="#1989fa" size="18" /></span>
                  <span class="info-label">收货地址:</span>
                  <span class="info-value">{{ bill.receiverAddress || '暂无' }}</span>
                </div>
              </div>
            </div>

            <div class="info-card">
              <div class="card-title">
                <van-icon name="clock" color="#1989fa" />
                <span>时间与航班</span>
              </div>
              <div class="info-group">
                <div class="info-row">
                  <span class="info-icon"><van-icon name="underway-o" color="#1989fa" size="18" /></span>
                  <span class="info-label">航班号:</span>
                  <span class="info-value">{{ bill.planeCode || '暂无' }}</span>
                </div>
                <div class="info-row">
                  <span class="info-icon"><van-icon name="guide-o" color="#1989fa" size="18" /></span>
                  <span class="info-label">航班描述:</span>
                  <span class="info-value">{{ bill.planDesc || '暂无' }}</span>
                </div>
                <div class="info-row">
                  <span class="info-icon"><van-icon name="todo-list-o" color="#1989fa" size="18" /></span>
                  <span class="info-label">发货日期:</span>
                  <span class="info-value accent">{{ bill.sendDate || '暂无' }}</span>
                </div>
                <div class="info-row">
                  <span class="info-icon"><van-icon name="completed" color="#1989fa" size="18" /></span>
                  <span class="info-label">到货日期:</span>
                  <span class="info-value accent">{{ bill.arrivalDate || '暂无' }}</span>
                </div>
              </div>
            </div>

            <!-- 图片展示区域 -->
            <div class="info-card" v-if="bill.image1 || bill.image2">
              <div class="card-title">
                <van-icon name="photo-o" color="#1989fa" />
                <span>物流图片</span>
              </div>
              <div class="image-list">
                <div class="image-item" v-if="bill.image1" @click="previewImage(bill.image1)">
                  <van-image :src="bill.image1" fit="cover" radius="8" width="120" height="120" />
                  <div class="image-overlay">
                    <van-icon name="search" size="20" color="#fff" />
                  </div>
                </div>
                <div class="image-item" v-if="bill.image2" @click="previewImage(bill.image2)">
                  <van-image :src="bill.image2" fit="cover" radius="8" width="120" height="120" />
                  <div class="image-overlay">
                    <van-icon name="search" size="20" color="#fff" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </van-tab>
      </van-tabs>
    </div>

    <!-- 操作按钮 - 只对顾客显示 -->
    <div class="action-buttons" v-if="!isEmployee && bill.status === 'TO_BE_PAY'">
      <van-button color="#1989fa" round block class="pay-btn" icon="balance-pay" @click="payBill">立即支付</van-button>
    </div>

    <div class="project-footer">
      唐光明鲜花快运
    </div>
  </div>
</template>

<script>
import { Tag, Dialog, Toast, Icon, Tabs, Tab, Button, Image, ImagePreview, Uploader } from 'vant'
import { getBillDetail, submitPay, getPayStatus, updateBill } from '@/api/bill'
import { getUserInfo } from '@/api/user'
import { uploadFile } from '@/api/common'
import { GOODS_NAME, BILL_STATUS, DELIVERY_TYPE, getDictLabel, getDictTagType } from '@/utils/dict'

export default {
  name: 'BillDetail',
  components: {
    [Tag.name]: Tag,
    [Icon.name]: Icon,
    [Tabs.name]: Tabs,
    [Tab.name]: Tab,
    [Button.name]: Button,
    [Image.name]: Image,
    [Uploader.name]: Uploader
  },
  data() {
    return {
      id: this.$route.params.id,
      activeTab: 'goods',
      bill: {},
      isEmployee: false,
      feedbackImages: [],
      // 添加字典对象引用
      GOODS_NAME,
      BILL_STATUS,
      DELIVERY_TYPE
    }
  },
  async created() {
    await this.checkUserRole()
    this.fetchBillDetail()

    if (this.$route.query.action === 'pay') {
      this.$nextTick(() => {
        if (this.bill.status === 'TO_BE_PAY') {
          this.payBill()
        }
      })
    }
  },
  methods: {
    // 添加字典查询方法
    getDictLabel,
    getDictTagType,
    
    // 检查用户角色
    async checkUserRole() {
      try {
        const res = await getUserInfo()
        if (res.code === 200 && res.user) {
          this.isEmployee = res.user.employee === true
        }
      } catch (error) {
        console.error('获取用户信息失败', error)
      }
    },
    
    // 添加图片预览方法
    previewImage(url) {
      ImagePreview([url]);
    },
    
    // 处理图片上传
    async afterRead(file) {
      try {
        Toast.loading({
          message: '上传中...',
          forbidClick: true,
          duration: 0
        })
        
        const res = await uploadFile(file.file)
        
        if (res.code === 200) {
          file.url = res.data
          Toast.clear()
          Toast.success('上传成功')
        } else {
          Toast.clear()
          Toast.fail(res.msg || '上传失败')
          // 移除失败的文件
          this.deleteImage(file)
        }
      } catch (error) {
        console.error('图片上传失败:', error)
        Toast.clear()
        Toast.fail('上传失败，请重试')
        // 移除失败的文件
        this.deleteImage(file)
      }
    },
    
    // 删除图片
    deleteImage(file) {
      const index = this.feedbackImages.findIndex(item => item === file)
      if (index > -1) {
        this.feedbackImages.splice(index, 1)
      }
    },
    
    // 提交反馈
    async submitFeedback() {
      if (this.feedbackImages.length === 0) {
        Toast('请至少上传一张图片')
        return
      }
      
      try {
        await Dialog.confirm({
          title: '提交反馈',
          message: `确认提交${this.feedbackImages.length}张反馈图片？`,
        })
        
        Toast.loading({
          message: '提交中...',
          forbidClick: true,
          duration: 0
        })
        
        // 准备提交数据
        const updateData = {
          id: this.bill.id,
          image1: this.feedbackImages[0]?.url || '',
          image2: this.feedbackImages[1]?.url || ''
        }
        
        // 调用更新账单接口
        const res = await updateBill(updateData)
        
        if (res.code === 200) {
          Toast.clear()
          Toast.success('反馈提交成功')
          
          // 更新本地账单数据
          this.bill.image1 = updateData.image1
          this.bill.image2 = updateData.image2
          
          // 清空上传的图片
          this.feedbackImages = []
        } else {
          Toast.clear()
          Toast.fail(res.msg || '提交失败，请重试')
        }
        
      } catch (error) {
        Toast.clear()
        if (error !== 'cancel') {
          console.error('提交反馈失败:', error)
          Toast.fail('提交失败，请重试')
        }
      }
    },
    
    async fetchBillDetail() {
      try {
        this.loading = true
        const res = await getBillDetail(this.id)
        
        if (res.code === 200) {
          this.bill = res.data
        } else {
          Toast(res.msg || '获取账单详情失败')
        }
      } catch (error) {
        console.error('获取账单详情出错', error)
        Toast('获取账单详情失败')
      } finally {
        this.loading = false
      }
    },
    
    async payBill() {
      try {
        await Dialog.confirm({
          title: '支付确认',
          message: `确认支付 ¥${this.bill.totalFee} 吗？`,
        });
        
        // 显示支付加载中
        Toast.loading({
          message: '正在拉起支付...',
          forbidClick: true,
          duration: 0, // 不自动关闭
        });
        
        // 调用支付接口获取支付参数
        const payRes = await submitPay(this.bill.id);
        
        if (payRes.code === 200) {
          Toast.clear();
          
          // 调用微信公众号支付
          this.invokeWechatPay(payRes.data);
        } else {
          Toast.clear();
          Toast.fail(payRes.msg || '支付失败');
        }
      } catch (error) {
        Toast.clear();
        if (error !== 'cancel') {
          Toast.fail(error);
        }
      }
    },
    
    // 调用微信公众号支付
    invokeWechatPay(payParams) {
      // 用于判断是否在微信环境下
      if (typeof window.WeixinJSBridge === "undefined") {
        if (document.addEventListener) {
          document.addEventListener('WeixinJSBridgeReady', () => this.onBridgeReady(payParams), false);
        } else if (document.attachEvent) {
          document.attachEvent('WeixinJSBridgeReady', () => this.onBridgeReady(payParams));
          document.attachEvent('onWeixinJSBridgeReady', () => this.onBridgeReady(payParams));
        } else {
          this.onBridgeReady(payParams);
        }
      } else {
        this.onBridgeReady(payParams);
      }
    },
    
    // 微信桥接准备就绪后调用支付
    onBridgeReady(payParams) {
      if (typeof window.WeixinJSBridge === 'undefined') {
        Toast.fail('请在微信中打开此页面进行支付');
        return;
      }
      
      window.WeixinJSBridge.invoke('getBrandWCPayRequest', {
        appId: payParams.appId,
        timeStamp: payParams.timeStamp,
        nonceStr: payParams.nonceStr,
        package: payParams.package,
        signType: payParams.signType,
        paySign: payParams.paySign
      }, (res) => {
        if (res.err_msg === 'get_brand_wcpay_request:ok') {
          // 支付成功，开始轮询支付状态
          Toast.loading({
            message: '支付处理中...',
            forbidClick: true,
            duration: 0,
          });
          
          this.pollPaymentStatus();
        } else if (res.err_msg === 'get_brand_wcpay_request:cancel') {
          // 用户取消支付
          Toast.fail('支付已取消');
        } else {
          // 支付失败
          Toast.fail('支付失败，请重试');
        }
      });
    },
    
        // 轮询支付状态
    async pollPaymentStatus() {
      let pollCount = 0;
      const maxPollCount = 50; // 最多轮询50次，每次100ms，总共5秒
      
      const pollInterval = setInterval(async () => {
        try {
          pollCount++;
          
          // 检查是否超时
          if (pollCount > maxPollCount) {
            clearInterval(pollInterval);
            Toast.clear();
            Toast.fail('支付状态查询超时，请手动刷新页面确认');
            return;
          }
          
          const statusRes = await getPayStatus(this.bill.id);
          
          if (statusRes.code === 200) {
            // 接口返回true表示支付成功，false表示未支付
            if (statusRes.data === true) {
              // 支付成功
              clearInterval(pollInterval);
              Toast.clear();
              Toast.success('支付成功');
              
              // 重新加载账单数据
              await this.fetchBillDetail();
              
            } else if (statusRes.data === false) {
              // 继续轮询，未支付
              console.log(`第${pollCount}次查询支付状态：未支付`);
            } else {
              // 其他情况，继续轮询
              console.log(`第${pollCount}次查询支付状态：`, statusRes.data);
            }
          } else {
            console.warn('获取支付状态失败', statusRes.msg);
            // 接口失败也继续轮询，直到超时
          }
        } catch (error) {
          console.error('轮询支付状态出错', error);
          // 出错也继续轮询，直到超时
        }
      }, 100); // 每100毫秒查询一次
    }
  }
}
</script>

<style scoped>
.bill-detail-container {
  background-color: #f6f9fc;
  font-family: -apple-system, BlinkMacSystemFont, 'Helvetica Neue', Helvetica, Segoe UI, Arial, Roboto, 'PingFang SC', sans-serif;
  min-height: 100vh;
  padding-bottom: 60px;
}

/* 顶部卡片样式 */
.header-card {
  background: linear-gradient(135deg, #1989fa, #39b9fa);
  color: white;
  padding: 20px 15px;
  border-radius: 0 0 16px 16px;
  box-shadow: 0 4px 12px rgba(25, 137, 250, 0.2);
  position: relative;
  margin-bottom: 10px;
}

.bill-info-header {
  margin-bottom: 8px;
}

.bill-code {
  font-size: 14px;
  opacity: 0.9;
  padding: 2px 0;
}

.bill-status-tag {
  position: absolute;
  top: 15px;
  right: 15px;
}

.bill-status-tag :deep(.van-tag) {
  font-weight: bold;
  padding: 2px 10px;
}

.amount-display {
  text-align: center;
  margin: 15px 0;
  display: flex;
  align-items: baseline;
  justify-content: center;
}

.amount-label {
  font-size: 16px;
  opacity: 0.9;
}

.amount-value {
  font-size: 28px;
  font-weight: bold;
  margin: 0 2px;
  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.amount-unit {
  font-size: 16px;
  opacity: 0.9;
}

.bill-basic-info {
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding: 0 5px;
  margin-top: 15px;
}

.info-chip {
  display: flex;
  align-items: center;
  background: rgba(77, 54, 107, 0.349);
  padding: 8px 12px;
  border-radius: 8px;
  font-size: 13px;
}

.info-chip .van-icon {
  margin-right: 8px;
  flex-shrink: 0;
}

/* 标签页样式 */
.tabs-container {
  position: relative;
  margin-top: 15px;
}

.tab-guide {
  position: absolute;
  top: -10px;
  right: 15px;
  display: flex;
  align-items: center;
  font-size: 12px;
  color: #ff4f00;
  z-index: 10;
  animation: pulse 2s infinite;
}

.guide-dot {
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background-color: #ff4f00;
  margin-right: 4px;
  animation: blink 1.5s infinite;
}

@keyframes pulse {
  0% { opacity: 0.7; }
  50% { opacity: 1; }
  100% { opacity: 0.7; }
}

@keyframes blink {
  0% { transform: scale(0.8); }
  50% { transform: scale(1.2); }
  100% { transform: scale(0.8); }
}

:deep(.van-tabs__wrap) {
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  border-radius: 10px;
  margin: 0 10px;
  overflow: hidden;
}

:deep(.van-tabs__nav) {
  background: linear-gradient(to right, #f6f9fc, #e9f2ff);
  padding: 5px;
  border-radius: 10px;
}

:deep(.van-tab) {
  padding: 0 16px;
  height: 60px;
  margin: 0 5px;
  border-radius: 8px;
  background-color: rgba(255, 255, 255, 0.7);
  transition: all 0.3s;
}

:deep(.van-tab--active) {
  background-color: white;
  box-shadow: 0 2px 10px rgba(25, 137, 250, 0.15);
  font-weight: 600;
  transform: translateY(-2px);
}

.custom-tab-title {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;
  font-weight: 500;
  position: relative;
}

.custom-tab-title .van-icon {
  margin-bottom: 3px;
  font-size: 22px;
  color: #1989fa;
}

.new-tag {
  position: absolute;
  top: 0;
  right: -1px;
  background-color: #ff4f00;
  color: white;
  font-size: 10px;
  padding: 1px 4px;
  border-radius: 8px;
  transform: scale(0.8);
  font-weight: normal;
}

:deep(.van-tabs__line) {
  height: 0;
  display: none;
}

.tab-content {
  padding: 15px;
}

/* 信息卡片样式 */
.info-card {
  background: white;
  border-radius: 12px;
  margin-bottom: 15px;
  padding: 15px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
}

.card-title {
  display: flex;
  align-items: center;
  font-size: 16px;
  font-weight: 600;
  color: #1989fa;
  margin-bottom: 15px;
  border-bottom: 1px solid #f0f0f0;
  padding-bottom: 10px;
}

.card-title .van-icon {
  margin-right: 6px;
  font-size: 18px;
}

.info-group {
  display: flex;
  flex-direction: column;
}

.info-row {
  display: flex;
  align-items: center;
  padding: 8px 0;
  border-bottom: 1px dashed #f0f0f0;
}

.info-row:last-child {
  border-bottom: none;
}

.info-icon {
  margin-right: 6px;
  width: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.info-label {
  color: #666;
  width: 80px;
  flex-shrink: 0;
  font-size: 14px;
}

.info-value {
  flex: 1;
  color: #333;
  font-size: 14px;
  word-break: break-all;
}

.info-value.accent {
  color: #1989fa;
  font-weight: 500;
}

/* 图片列表样式 */
.image-list {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  margin-top: 10px;
}

.image-item {
  position: relative;
  cursor: pointer;
  transition: transform 0.2s;
}

.image-item:hover {
  transform: scale(1.03);
}

.image-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.3);
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  opacity: 0;
  transition: opacity 0.2s;
}

.image-item:hover .image-overlay {
  opacity: 1;
}

/* 费用卡片样式 */
.fee-list {
  padding-top: 10px;
}

.fee-item {
  display: flex;
  justify-content: space-between;
  padding: 6px 0;
  border-bottom: 1px dashed #f0f0f0;
}

.fee-label {
  color: #666;
  font-size: 14px;
}

.fee-value {
  color: #333;
  font-weight: 500;
  font-size: 15px;
}

.fee-item.total {
  border-top: 1px solid #ebedf0;
  border-bottom: none;
  margin-top: 8px;
  padding-top: 15px;
}

.fee-item.total .fee-label {
  font-weight: bold;
  color: #333;
}

.fee-item.total .fee-value {
  color: #f44;
  font-size: 18px;
  font-weight: bold;
}

.fee-item.total.paid .fee-value {
  color: #07c160;
}

/* 操作按钮样式 */
.action-buttons {
  padding: 15px;
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  background: rgba(255, 255, 255, 0.9);
  backdrop-filter: blur(10px);
  z-index: 999;
  box-shadow: 0 -2px 10px rgba(0, 0, 0, 0.05);
}

.pay-btn {
  height: 44px;
  font-size: 16px;
  font-weight: 500;
}

.project-footer {
  text-align: center;
  font-size: 13px;
  color: #999;
  margin: 3px 0;
  padding-bottom: 25px;
}

/* 送货员反馈样式 */
.feedback-section {
  padding: 10px 0;
}

.feedback-label {
  font-size: 14px;
  color: #666;
  margin-bottom: 10px;
}

.feedback-actions {
  margin-top: 15px;
}

.preview-cover {
  position: absolute;
  top: 0;
  right: 0;
  width: 20px;
  height: 20px;
  background: rgba(0, 0, 0, 0.7);
  border-radius: 0 0 0 12px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.preview-cover .van-icon {
  font-size: 12px;
  color: white;
}

/* 反馈状态样式 */
.feedback-status {
  padding: 15px 0;
}

.status-message {
  display: flex;
  align-items: center;
  justify-content: center;
  background: #f0f9eb;
  padding: 15px;
  border-radius: 8px;
  color: #07c160;
  font-size: 14px;
}

.status-message .van-icon {
  margin-right: 8px;
}

.feedback-images {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  margin-top: 15px;
}

.feedback-image-item {
  position: relative;
  cursor: pointer;
  transition: transform 0.2s;
}

.feedback-image-item:hover {
  transform: scale(1.03);
}

.feedback-image-item .image-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.3);
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  opacity: 0;
  transition: opacity 0.2s;
}

.feedback-image-item:hover .image-overlay {
  opacity: 1;
}
</style>
